import { render, staticRenderFns } from "./ThirdRouterNav.vue?vue&type=template&id=aa89884c&scoped=true&"
import script from "./ThirdRouterNav.vue?vue&type=script&lang=js&"
export * from "./ThirdRouterNav.vue?vue&type=script&lang=js&"
import style0 from "./ThirdRouterNav.vue?vue&type=style&index=0&id=aa89884c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89884c",
  null
  
)

export default component.exports